module.exports = __webpack_public_path__ + "static/media/bg-live-match-alt.1dfb9f2c.png";